import { compose, path, split, partialRight } from 'ramda'

const splitByDot = split('.')

const searchableComponent = (boundedCallback: () => void): any =>
  compose(partialRight(path, [boundedCallback()]), splitByDot)

export { searchableComponent }
